module.exports = __webpack_public_path__ + "static/media/share-alt.ac1a4916.svg";